import Plyr from 'plyr';

export default () => {
  let videos = document.querySelectorAll('.video__holder');

  if (!videos) {
    return;
  }

  localStorage.clear();

  videos.forEach(function (video) {
    const player = new Plyr(video, {
      controls: ['play-large', 'play', 'progress', 'volume', 'fullscreen'],
      // hideControls: false,
      // fullscreen: {
      //   enabled: false,
      // },
      // tooltips: {
      //   controls: false,
      //   seek: false,
      // },
      storage: {
          enabled: false
      },
      fullscreen: {
        enabled: true,  iosNative: true
      },
      autoplay: false,
      volume: 1,
      clickToPlay: true,
      // muted: true,
      loop: {
        active: true,
      },
    });

    // console.log(video, player)
    const parent = video.closest('.video');

    // if(window.innerWidth < 1100) {
    //   parent.addEventListener('click', () => {
    //         player.on('playing', (event) => {
    //             parent.classList.add('video--playing');
    //         });
    //     if(parent.classList.contains('video--playing')) {
    //       player.pause();
    //     } else {
    //       player.play();
    //     }
    //   });
    // }

    player.on('playing', (event) => {
      parent.classList.add('video--playing');
    });
    player.on('pause', (event) => {
      parent.classList.remove('video--playing');
    });
  });
};

